module.exports = __webpack_public_path__ + "static/media/layer_3.4959d331.png";